import { render } from "./AddAuxEngineEnergySavingsComponent.vue?vue&type=template&id=54a1acb8&scoped=true"
import script from "./AddAuxEngineEnergySavingsComponent.vue?vue&type=script&lang=js"
export * from "./AddAuxEngineEnergySavingsComponent.vue?vue&type=script&lang=js"

import "./AddAuxEngineEnergySavingsComponent.vue?vue&type=style&index=0&id=54a1acb8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a1acb8"]])

export default __exports__